import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './auth/loginPage';
import Dashboard from './views/dashboard/page';
import AccessDenied from './modules/accessDenied/accessDeniedPage';
import Files from './modules/services/files/filesPage';
import Reports from './modules/services/reports/reportsPage';
import Forms from './modules/services/forms/formsPage';
import Admin from './modules/adminPanel/adminPanelPage';
// import UserManagement from './modules/adminPanel/adminPanelSubPages/usersManagementPage';
// import UserProfile from './modules/adminPanel/adminPanelSubPages/userProfile';
import ContactCenterPage from './modules/contactCenter/contactCenterPage';
import RepairPage from './modules/repair/repairPage';
import { AuthProvider } from './context/authContext';
import { ProtectedRoute } from './context/protectedRoute';
import { LicenseInfo } from '@mui/x-license';
import RSSTracking from './views/rss/page';
import NotFound from './views/notFound/page';
import LanguageProvider from './hooks/languageProvider';
// import Groups from './modules/adminPanel/adminPanelSubPages/groupsManagementPage';
// import UserInvitesManagement from './modules/adminPanel/adminPanelSubPages/userInvitesManagementPage';
import SkillingSheetPage from './modules/adminPanel/workforceManagement/skillingSheet/page';
import AuthenticatedLayout from './modules/copilot/authenticatedLayout';

const muiXLicenseKey = process.env.REACT_APP_MUI_X_LICENSE_KEY;
LicenseInfo.setLicenseKey(muiXLicenseKey);

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <Router>
          <Routes>
            {/* Standard Routes */}
            <Route path='/' element={<Login />} />
            <Route path='/login' element={<Login />} />
            <Route path='/denied' element={<AccessDenied />} />

            {/* Authenticated Routes */}
            {/* Admin Routes */}
            <Route element={<AuthenticatedLayout />}>
              <Route
                path='/admin'
                element={<ProtectedRoute element={<Admin />} path='/admin' />}
              />
              <Route
                path='/admin/workforce/skilling-sheet'
                element={
                  <ProtectedRoute
                    element={<SkillingSheetPage />}
                    path='/admin/workforce/skilling-sheet'
                  />
                }
              />
              {/* <Route
              path='/admin/users'
              element={
                <ProtectedRoute
                  element={<UserManagement />}
                  path='/admin/users'
                />
              }
            />
            <Route
              path='/admin/users/invites'
              element={
                <ProtectedRoute
                  element={<UserInvitesManagement />}
                  path={'/admin/users/invites'}
                />
              }
            />
            <Route
              path='/admin/users/:userId'
              element={
                <ProtectedRoute
                  element={<UserProfile />}
                  path='/admin/users/:userId'
                />
              }
            /> */}
              {/* <Route
              path='/admin/platform-apis'
              element={
                <ProtectedRoute
                  element={<PlatformAPI />}
                  path='/admin/platform-apis'
                />
              }
            /> */}
              {/* <Route
              path='/admin/groups'
              element={
                <ProtectedRoute element={<Groups />} path='/admin/groups' />
              }
            /> */}

              {/* Dashboard Route */}
              <Route
                path='/home'
                element={
                  <ProtectedRoute element={<Dashboard />} path='/home' />
                }
              />

              {/* Reports Route */}
              <Route
                path='/reports'
                element={
                  <ProtectedRoute element={<Reports />} path='/reports' />
                }
              />

              {/* RSS Route */}
              <Route
                path='/rss/links'
                element={
                  <ProtectedRoute element={<RSSTracking />} path='/rss/links' />
                }
              />

              {/* Forms Route */}
              <Route
                path='/forms'
                element={<ProtectedRoute element={<Forms />} path='/forms' />}
              />

              {/* Files Routes */}
              <Route
                path='/files'
                element={<ProtectedRoute element={<Files />} path='/files' />}
              />
              <Route
                path='/files/:country/:organization/:team'
                element={
                  <ProtectedRoute
                    element={<Files />}
                    path='/files/:country/:organization/:team'
                  />
                }
              />

              {/* Contact Center Routes */}
              <Route
                path='/contact-center/*'
                element={
                  <ProtectedRoute
                    element={<ContactCenterPage />}
                    path='/contact-center'
                  />
                }
              />

              {/* Depot Route */}
              <Route
                path='/repair/search'
                element={
                  <ProtectedRoute
                    element={<RepairPage />}
                    path='/repair/search'
                  />
                }
              />
              <Route
                path='/repair/rrf'
                element={
                  <ProtectedRoute element={<RepairPage />} path='/repair/rrf' />
                }
              />
              <Route
                path='/repair/search/:repair-order/:qrCode'
                element={
                  <ProtectedRoute
                    element={<RepairPage />}
                    path='/repair/search/:repair-order/:qrCode'
                  />
                }
              />
            </Route>

            {/* Not Found Route */}
            <Route path='*' element={<NotFound />} />
          </Routes>
        </Router>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
